import { inject, NewInstance } from 'aurelia-framework';
import { StatusService } from 'pages/system-fields/statuses/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), StatusService, EventAggregator)
export class StatusEditor {
    constructor(controller, validationController, statusService, ea) {
        this.controller = controller;
        this.statusService = statusService;
        this.ea = ea;
        this.status = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.status = await this.statusService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.status.id) {
                    await this.statusService.update(this.status);
                    toastr.success('Status was updated!');
                } else {
                    await this.statusService.create(this.status);
                    toastr.success('New status was created!');
                }
                this.ea.publish('statuses:updated', this.status);
                this.controller.ok(this.status);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}